import React, { useState } from 'react';
import { useFormik } from "formik";
import { Button, Modal } from "react-bootstrap";
import InputMask from "react-input-mask";
import { ModalProgressBar } from "../../../../_metronic/_partials/controls";
import ClientRegisterValidator from '../../../../helpers/validators/ClientRegisterValidator';
import * as clientService from "../../../../services/management/clientService";
import * as alert from "../../../../redux/alertSnackBarRedux";
import { getInputClasses, convertJsonToFormData } from "../../../../helpers/helper";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { connect } from 'react-redux';

const AddClientModal = (props) => {
    const { isVisible, showAlert, closeModal, clientRegisterHandler } = props;
    const [initialValues, setInitialValues] = useState(
        {
            accountNumber: '',
            name: '',
            primaryPhone: '',
            email: '',
            phoneNumber: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zipCode: '',
            isActive: true,
            duplicateAsLocation: true
        }
    )
    const [loading, setloading] = useState(false);

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: ClientRegisterValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            registerClientHandler(values, setStatus, setSubmitting);
        }
    });
    const registerClientHandler = (values, setStatus, setSubmitting) => {
        setloading(true);
        values.address = {
            address1: values.address1,
            address2: values.address2,
            city: values.city,
            state: values.state,
            zipCode: values.zipCode
        }

        registerClient(values, setSubmitting);
    };

    const registerClient = (values, setSubmitting) => {
        clientService.saveClient(convertJsonToFormData(values)).then(res => {
            showAlert({ message: res.message, variant: 'success' });
            clientRegisterHandler({
                clientId: res.clientId, locationId: res.locationId, name: values.contactName, phone: values.primaryPhone, email: values.email
            });
            formik.resetForm();
        }).catch(ex => showAlert({ message: ex.message, variant: 'error' }))
            .finally(() => setloading(false), setSubmitting(false))
    }


    return (
        <Modal size={"lg"} show={isVisible} onHide={() => closeModal()}>
            <Modal.Header closeButton>
                <Modal.Title>Add Client</Modal.Title>
            </Modal.Header>
            <form
                className="card card-custom card-stretch mt"
                onSubmit={formik.handleSubmit}
            >
                <Modal.Body>
                    {loading && <ModalProgressBar />}
                    <div className="form mt-lg-n10">
                        <div className="row">
                            <label className="col-xl-3"></label>
                            <div className="col-lg-12 col-xl-9">
                                <h5 className="mt-lg-10 mb-6 fz-md fw-700 c-primary">Client Info</h5>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Business Name*
                                </label>
                            <div className="col-lg-12 col-xl-9">
                                <input
                                    type="text"
                                    placeholder="XYZ Company"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "name")}`}
                                    name="name"
                                    {...formik.getFieldProps("name")}
                                />
                                {formik.touched.name && formik.errors.name ? (
                                    <div className="invalid-feedback">
                                        {formik.errors.name}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        {/* <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Account Number
                                </label>
                            <div className="col-lg-12 col-xl-9">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Mail-at.svg")} /> </span>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="0012345"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "accountNumber")}`}
                                        name="accountNumber"
                                        {...formik.getFieldProps("accountNumber")}
                                    />
                                </div>
                                {formik.touched.accountNumber && formik.errors.accountNumber ? (
                                    <div className="invalid-feedback">
                                        {formik.errors.accountNumber}
                                    </div>
                                ) : null}
                            </div>
                        </div> */}
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Contact Name
                        </label>
                            <div className="col-lg-12 col-xl-9">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} /> </span>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="John Doe"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "contactName")}`}
                                        name="contactName"
                                        {...formik.getFieldProps("contactName")}
                                    />
                                </div>
                                {formik.touched.contactName && formik.errors.contactName ? (
                                    <div className="invalid-feedback">
                                        {formik.errors.contactName}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Email Address
                                </label>
                            <div className="col-lg-12 col-xl-9">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Mail.svg")} /> </span>
                                        </span>
                                    </div>
                                    <input
                                        type="email"
                                        placeholder="Email"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "email")}`}
                                        name="email"
                                        {...formik.getFieldProps("email")}
                                    />
                                </div>
                                {formik.touched.email && formik.errors.email ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.email}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Contact Phone
                                </label>
                            <div className="col-lg-12 col-xl-9">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Adress-book1.svg")} /> </span>                                        </span>
                                    </div>
                                    <InputMask
                                        mask="(999) 999-9999"
                                        type="text"
                                        placeholder="(225)-000-0000"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "primaryPhone")}`}
                                        name="primaryPhone"
                                        {...formik.getFieldProps("primaryPhone")}
                                    />
                                </div>
                                {formik.touched.primaryPhone && formik.errors.primaryPhone ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.primaryPhone}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="row">
                            <label className="col-xl-3"></label>
                            <div className="col-lg-12 col-xl-9">
                                <h5 className="mt-lg-10 mb-6 fz-md fw-700 c-primary">Address Info</h5>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Address 1*
                                </label>
                            <div className="col-lg-12 col-xl-9">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className="fa fa-home"></i>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="123 Second St."
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "address1")}`}
                                        name="address1"
                                        {...formik.getFieldProps("address1")}
                                    />
                                </div>
                                {formik.touched.address1 && formik.errors.address1 ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.address1}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Address 2
                                </label>
                            <div className="col-lg-12 col-xl-9">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className="fa fa-building"></i>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Apt# 1"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "address2")}`}
                                        name="address2"
                                        {...formik.getFieldProps("address2")}
                                    />
                                </div>
                                {formik.touched.address2 && formik.errors.address2 ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.address2}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                City*
                                </label>
                            <div className="col-lg-12 col-xl-9">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className="fa fa-city"></i>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Baton Rouge"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "city")}`}
                                        name="city"
                                        {...formik.getFieldProps("city")}
                                    />
                                </div>
                                {formik.touched.city && formik.errors.city ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.city}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                State*
                                </label>
                            <div className="col-lg-12 col-xl-9">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className="fa fa-flag-usa"></i>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Louisiana"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "state")}`}
                                        name="state"
                                        {...formik.getFieldProps("state")}
                                    />
                                </div>
                                {formik.touched.state && formik.errors.state ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.state}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Zip Code*
                                </label>
                            <div className="col-lg-12 col-xl-9">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className="fa fa-location-arrow"></i>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="70809"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "zipCode")}`}
                                        name="zipCode"
                                        {...formik.getFieldProps("zipCode")}
                                    />
                                </div>
                                {formik.touched.zipCode && formik.errors.zipCode ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.zipCode}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => closeModal()}>
                        Close
                    </Button>
                    <Button disabled={loading} type="submit">
                        Create Client
                    </Button>
                </Modal.Footer>
            </form>

        </Modal>

    )
}

export default connect(null, alert.actions)(AddClientModal);